'use client';

import { fetchGoodsList } from '@/api/product';
import ProductCard from '@/components/Product/ProductCard';
import SortMenu from '@/components/SortMenu';
import { useStore } from '@/providers/app-store-provider';
import logger from '@/utils/client-logger';
import { DEFAULT_SORT_VALUE } from '@/utils/constants';
import { env } from '@/utils/env';
import { useMemo, useState } from 'react';

export default function PersonalityGoodsLists({
  listPart,
  serverList,
}: {
  listPart: any;
  serverList: any[];
}) {
  const currency = useStore((s) => s.currency);
  const publicResourceData = useStore((s) => s.publicResourceData);
  const [sort, setSort] = useState<string>(DEFAULT_SORT_VALUE);
  const [list, setList] = useState<any[]>(serverList);

  const product_sort_new = useMemo(() => {
    try {
      return publicResourceData.config_names.product_sort_new;
    } catch {
      return [] as any[];
    }
  }, [publicResourceData]);

  const title = listPart?.title || '';
  const groupId = Number(listPart?.group) || 0;

  const fetchList = async (sortValue: string) => {
    if (!groupId) return;
    try {
      const order = sortValue === '' || sortValue === DEFAULT_SORT_VALUE ? '' : sortValue;
      const { data } = (await fetchGoodsList({
        currency: currency?.name || env.NEXT_PUBLIC_DEFAULT_CURRENCY,
        group_id: groupId,
        limit: 1000,
        page: 1,
        in_stock: 1,
        is_sale: 1,
        order,
        append_correlation: 1,
      } as any)) as any;
      setList(Array.isArray(data?.list) ? data.list : []);
    } catch (e) {
      logger.error('Error fetching goods list:', e);
      setList([]);
    }
  };

  const sortOptions = useMemo(() => {
    return product_sort_new.map((item) => ({
      label: item.name,
      value: item.value || DEFAULT_SORT_VALUE,
    }));
  }, [product_sort_new]);

  return (
    <div className="personality-goods-list bg-[#ffffff] p-[4.115vw_10.417vw_2.344vw]">
      {title && (
        <p className="title text-center text-primary-black font-bb text-[2.917vw]">{title}</p>
      )}
      <div className={`sort-filter-bar sticky bg-[#ffffff] z-3 top-[100px]`}>
        <div className={`flex items-center py-10 flex-row-reverse }`}>
          {/* 排序菜单 */}
          <div className={`flex items-center min-[920px]:ml-auto`}>
            <SortMenu
              options={sortOptions}
              value={sort === '' ? DEFAULT_SORT_VALUE : sort}
              onChange={(value) => {
                setSort(value as string);
                fetchList(value as string);
              }}
              buttonStyle={{
                padding: '8px 12px 8px 0',
                minWidth: 'auto',
                fontSize: '14px',
                fontWeight: 'normal',
              }}
            />
          </div>
        </div>
      </div>

      <div
        className={`grid grid-cols-4 gap-x-[16px] gap-y-[24px] mb-[2.08vw] max-[1568px]:grid-cols-3 max-[1280px]:grid-cols-2 max-[1024px]:grid-cols-1`}
      >
        {list.map((product: any, index) => (
          <ProductCard
            key={`${product?.id || index}`}
            product={product}
            index={index}
            showCorrelation
            showReviewStar
            showTryOn={false}
            showMember
            showTag
            showOriginalPrice
            showName={false}
            showWishNum={false}
            nameSuffix="Personality"
            imageClassName="!aspect-[1/1] !rounded-[6px]"
          />
        ))}
      </div>
    </div>
  );
}
